import React from "react";
import "../styles/TermsOfService.css"; // Ensure you have this CSS file for styling

const TermsOfService = () => {
  return (
    <div className="terms-container">
      <h1>Terms of Service</h1>
      <p>Effective Date: March 2025</p>

      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>By accessing and using RixxyMC, you agree to comply with these Terms of Service. If you do not agree, please do not use our server or website.</p>
      </section>

      <section>
        <h2>2. User Conduct & Responsibilities</h2>
        <ul>
          <li>Cheating, hacking, or exploiting game mechanics is strictly prohibited.</li>
          <li>Respect all players and staff. No harassment, hate speech, or toxic behavior.</li>
          <li>Do not advertise, spam, or share malicious links.</li>
          <li>Follow all server rules and guidelines as enforced by staff.</li>
        </ul>
      </section>

      <section>
        <h2>3. Account & Security</h2>
        <p>You are responsible for securing your Minecraft account. RixxyMC is not liable for any unauthorized access or account misuse.</p>
      </section>

      <section>
        <h2>4. Payments & Donations</h2>
        <p>
          Purchases and donations made on RixxyMC are **non-refundable**. Chargebacks or payment disputes may result in a **permanent ban** from our services.
        </p>
      </section>

      <section>
        <h2>5. Content Ownership & Usage</h2>
        <p>By playing on RixxyMC, you grant us permission to use your in-game creations, screenshots, and interactions for promotional purposes.</p>
      </section>

      <section>
        <h2>6. Enforcement & Punishments</h2>
        <ul>
          <li>Breaking rules may result in a warning, mute, kick, or ban.</li>
          <li>All staff decisions are final. Attempting to bypass a ban is prohibited.</li>
          <li>RixxyMC reserves the right to deny access to any player for any reason.</li>
        </ul>
      </section>

      <section>
        <h2>7. Disclaimer of Liability</h2>
        <p>RixxyMC is provided "as-is" without warranties. We are not responsible for lost in-game items, data corruption, or server downtime.</p>
      </section>

      <section>
        <h2>8. Amendments & Changes</h2>
        <p>We may update these Terms at any time. Continued use of RixxyMC means you accept any changes.</p>
      </section>

      <section>
        <h2>9. Contact & Support</h2>
        <p>If you have questions, contact us at <a href="mailto:support@rixxymc.fun">support@rixxymc.fun</a>.</p>
      </section>
    </div>
  );
};

export default TermsOfService;
